import SendbirdSDK from '../sendbird_sdk'

export default {
  mounted() {
    window.liveView = this

    // # Configure and initialize the Parent Messages SDK

    // ## SDK -> LiveView
    //
    // Define callbacks to handle data sent from the SDK to LiveView
    const callbacks = {
      onConversationsLoad: data => {
        window.liveView.pushEvent('from-sdk.update-conversations', data)
      },
      onActiveConversationLoad: data => {
        window.liveView.pushEvent('from-sdk.update-active-conversation', data)
      },
      onSearchMessagesLoad: data => {
        window.liveView.pushEvent('from-sdk.update-search-messages', data)
      },
      onMessageReceived: data => {
        window.liveView.pushEvent('from-sdk.message-received', data)
      },
      onMessageSent: data => {
        window.liveView.pushEvent('from-sdk.message-sent', data)
      },
      onMoreMessagesLoaded: data => {
        window.liveView.pushEvent('from-sdk.messages-fetched', data)
      },
      onError: (sendbirdError, sdkSource) => {
        window.liveView.pushEvent('from-sdk.sendbird-error', {
          error: {
            message: sendbirdError.message,
            name: sendbirdError.name,
            code: sendbirdError.code,
            sdkSource
          }
        })
      }
    }

    // ## Create the SDK instance
    //
    // This code assumes the Parent Messages SDK will require some
    // initial data to create the connection and fetch data.
    //
    // The initial data in this example is the `token` value. This is
    // defined on the server side. The LiveView instance takes this value
    // and passes it here through an HTML `data-*` attribute in the `.heex`
    // template. For example:
    //
    //    <div
    //      id="parent-messages"
    //      phx-hook="ParentMessages"
    //      data-app-id={@app_id}
    //      data-user-id={@current_user.id}
    //      data-access-token={@access_token}
    //      data-active-conversation-id={@active_conversation_id}
    //    >
    //      ...
    //    </div>
    //
    const appId = this.el.dataset.appId
    const userId = this.el.dataset.userId
    const accessToken = this.el.dataset.accessToken
    const fetchAllConversations = this.el.hasAttribute('data-fetch-on-mount')

    SendbirdSDK.init(appId, userId, accessToken, callbacks).then(sb => {
      // ## LiveView -> SDK
      //
      // Define listeners to handle data sent from the LiveView to the SDK
      window.liveView.handleEvent('to-sdk.get-all-conversations', () => {
        sb.getAllConversations()
      })

      window.liveView.handleEvent('to-sdk.select-active-conversation', data => {
        sb.selectActiveConversation(data.id)
      })

      window.liveView.handleEvent('to-sdk.send-message', data => {
        document.getElementById('send_message_message').value = ''
        sb.sendMessage(data.message)
      })

      window.liveView.handleEvent('to-sdk.fetch-more-messages', () => {
        sb.fetchMoreMessages()
      })

      window.liveView.handleEvent('to-sdk.search-messages', data => {
        document.getElementById('search_messages_search').value = ''
        sb.searchMessages(data)
      })

      // ## Fetch data on mount
      //
      // Request some data from the SDK automatically when the LiveView mounts
      const activeConversationId = window.liveView.el.dataset.activeConversationId

      if (fetchAllConversations) {
        sb.getAllConversations()
      }

      if (activeConversationId) {
        sb.selectActiveConversation(activeConversationId)
      }
    }).catch(error => { callbacks.onError(error) })
  },

  destroyed() {
    if (window.sendbird) {
      console.log(`INFO: Disconnecting Sendbird from destroyed`)
      window.sendbird.disconnect()
    }
  },

  disconnected() {
    if (window.sendbird) {
      console.log(`INFO: Disconnecting Sendbird from disconnected`)
      window.sendbird.disconnect()
    }
  },

  reconnected() { },
}
